import theme from "@/theme";
import { SVGProps } from "react";
const AtmSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
    <path
      stroke={theme.palette.custom.mainBlue}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19 3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-1.5M6.5 16H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14M12 15V7"
    />
    <path
      stroke={theme.palette.custom.mainBlue}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15 12h1.5a1 1 0 0 1 1 1v6a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-6a1 1 0 0 1 1-1H9M14 9l-2-2-2 2"
    />
  </svg>
);
export default AtmSvg;
